<div
  [style]="contentStyle"
  [class]="[baseCssConfig?.borderClass !== 'none' ? baseCssConfig?.borderClass : '', 'pointer-events-none']"
>
  <div [style]="{ maxHeight: containerHeight, overflowY: 'auto' }" id="companies-house-list" class="w-100">
    @if (companies.length > 0 && !appBuilderShowNoRecordsContent && !appBuilderShowFetchingContent) {
    <div class="w-100">
      @for (company of companies; track company.companyNumber) {
      <finxone-web-frontend-list-item [content]="widgetProperties?.['listItemTemplate']"
        [customHandlebarModel]="{ company: company, index: $index }"
        [customClass]="isGlobalStylingEnabled ? 'global-list-styling' : ''" [class.disabled]="isApiInProgress"
        (itemClicked)="onSelectCompany(company)"></finxone-web-frontend-list-item>
      }
    </div>
    } @else {
    @if (isApiInProgress || appBuilderShowFetchingContent) {
    <div [innerHTML]="renderedFetchingTemplate | safeHtml"></div>
    } @else {
    <div [innerHTML]="renderedNoResultsTemplate | safeHtml"></div>
    }
    }
  </div>
</div>